module.exports = __webpack_public_path__ + "img/charity_box.f8dc79b1.svg";